export const LOGOUT = 'LOGOUT'

export const SET_ERROR = 'SET_ERROR'
export const REQUEST_STATE = 'REQUEST_STATE'

//USER
export const CORE_USER_VERIFY_REQUEST = 'CORE_USER_VERIFY_REQUEST'
export const CORE_USER_VERIFY_SUCCESS = 'CORE_USER_VERIFY_SUCCESS'
export const CORE_USER_VERIFY_FAILURE = 'CORE_USER_VERIFY_FAILURE'

export const CORE_USER_LOGOUT_REQUEST = 'CORE_USER_LOGOUT_REQUEST'
export const CORE_USER_LOGOUT_SUCCESS = 'CORE_USER_LOGOUT_SUCCESS'
export const CORE_USER_LOGOUT_FAILURE = 'CORE_USER_LOGOUT_FAILURE'

export const CORE_LOAD_ALL_USER_REQUEST = 'CORE_LOAD_ALL_USER_REQUEST'
export const CORE_LOAD_ALL_USER_SUCCESS = 'CORE_LOAD_ALL_USER_SUCCESS'
export const CORE_LOAD_ALL_USER_FAILURE = 'CORE_LOAD_ALL_USER_FAILURE'

export const CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST'
export const CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS'
export const CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE'

export const CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST'
export const CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS'
export const CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE'

export const CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST'
export const CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS'
export const CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE'

export const CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST'
export const CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS'
export const CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE'

//CUSTOMER
export const CORE_LOAD_ALL_CUSTOMER_REQUEST = 'CORE_LOAD_ALL_CUSTOMER_REQUEST'
export const CORE_LOAD_ALL_CUSTOMER_SUCCESS = 'CORE_LOAD_ALL_CUSTOMER_SUCCESS'
export const CORE_LOAD_ALL_CUSTOMER_FAILURE = 'CORE_LOAD_ALL_CUSTOMER_FAILURE'

export const CORE_LOAD_CUSTOMER_REQUEST = 'CORE_LOAD_CUSTOMER_REQUEST'
export const CORE_LOAD_CUSTOMER_SUCCESS = 'CORE_LOAD_CUSTOMER_SUCCESS'
export const CORE_LOAD_CUSTOMER_FAILURE = 'CORE_LOAD_CUSTOMER_FAILURE'

export const CORE_DELETE_CUSTOMER_REQUEST = 'CORE_DELETE_CUSTOMER_REQUEST'
export const CORE_DELETE_CUSTOMER_SUCCESS = 'CORE_DELETE_CUSTOMER_SUCCESS'
export const CORE_DELETE_CUSTOMER_FAILURE = 'CORE_DELETE_CUSTOMER_FAILURE'

export const CORE_CREATE_CUSTOMER_REQUEST = 'CORE_CREATE_CUSTOMER_REQUEST'
export const CORE_CREATE_CUSTOMER_SUCCESS = 'CORE_CREATE_CUSTOMER_SUCCESS'
export const CORE_CREATE_CUSTOMER_FAILURE = 'CORE_CREATE_CUSTOMER_FAILURE'

export const CORE_UPDATE_CUSTOMER_REQUEST = 'CORE_UPDATE_CUSTOMER_REQUEST'
export const CORE_UPDATE_CUSTOMER_SUCCESS = 'CORE_UPDATE_CUSTOMER_SUCCESS'
export const CORE_UPDATE_CUSTOMER_FAILURE = 'CORE_UPDATE_CUSTOMER_FAILURE'

//CONTACT
export const CORE_LOAD_ALL_CONTACT_REQUEST = 'CORE_LOAD_ALL_CONTACT_REQUEST'
export const CORE_LOAD_ALL_CONTACT_SUCCESS = 'CORE_LOAD_ALL_CONTACT_SUCCESS'
export const CORE_LOAD_ALL_CONTACT_FAILURE = 'CORE_LOAD_ALL_CONTACT_FAILURE'

export const CORE_LOAD_SEARCH_CONTACT_REQUEST = 'CORE_LOAD_SEARCH_CONTACT_REQUEST'
export const CORE_LOAD_SEARCH_CONTACT_SUCCESS = 'CORE_LOAD_SEARCH_CONTACT_SUCCESS'
export const CORE_LOAD_SEARCH_CONTACT_FAILURE = 'CORE_LOAD_SEARCH_CONTACT_FAILURE'

export const CORE_LOAD_CONTACT_REQUEST = 'CORE_LOAD_CONTACT_REQUEST'
export const CORE_LOAD_CONTACT_SUCCESS = 'CORE_LOAD_CONTACT_SUCCESS'
export const CORE_LOAD_CONTACT_FAILURE = 'CORE_LOAD_CONTACT_FAILURE'

export const CORE_DELETE_CONTACT_REQUEST = 'CORE_DELETE_CONTACT_REQUEST'
export const CORE_DELETE_CONTACT_SUCCESS = 'CORE_DELETE_CONTACT_SUCCESS'
export const CORE_DELETE_CONTACT_FAILURE = 'CORE_DELETE_CONTACT_FAILURE'

export const CORE_CREATE_CONTACT_REQUEST = 'CORE_CREATE_CONTACT_REQUEST'
export const CORE_CREATE_CONTACT_SUCCESS = 'CORE_CREATE_CONTACT_SUCCESS'
export const CORE_CREATE_CONTACT_FAILURE = 'CORE_CREATE_CONTACT_FAILURE'

export const CORE_UPDATE_CONTACT_REQUEST = 'CORE_UPDATE_CONTACT_REQUEST'
export const CORE_UPDATE_CONTACT_SUCCESS = 'CORE_UPDATE_CONTACT_SUCCESS'
export const CORE_UPDATE_CONTACT_FAILURE = 'CORE_UPDATE_CONTACT_FAILURE'

//PROFILE
export const CORE_LOAD_ALL_PROFILE_REQUEST = 'CORE_LOAD_ALL_PROFILE_REQUEST'
export const CORE_LOAD_ALL_PROFILE_SUCCESS = 'CORE_LOAD_ALL_PROFILE_SUCCESS'
export const CORE_LOAD_ALL_PROFILE_FAILURE = 'CORE_LOAD_ALL_PROFILE_FAILURE'

export const CORE_LOAD_PROFILE_REQUEST = 'CORE_LOAD_PROFILE_REQUEST'
export const CORE_LOAD_PROFILE_SUCCESS = 'CORE_LOAD_PROFILE_SUCCESS'
export const CORE_LOAD_PROFILE_FAILURE = 'CORE_LOAD_PROFILE_FAILURE'

export const CORE_DELETE_PROFILE_REQUEST = 'CORE_DELETE_PROFILE_REQUEST'
export const CORE_DELETE_PROFILE_SUCCESS = 'CORE_DELETE_PROFILE_SUCCESS'
export const CORE_DELETE_PROFILE_FAILURE = 'CORE_DELETE_PROFILE_FAILURE'

export const CORE_CREATE_PROFILE_REQUEST = 'CORE_CREATE_PROFILE_REQUEST'
export const CORE_CREATE_PROFILE_SUCCESS = 'CORE_CREATE_PROFILE_SUCCESS'
export const CORE_CREATE_PROFILE_FAILURE = 'CORE_CREATE_PROFILE_FAILURE'

export const CORE_UPDATE_PROFILE_REQUEST = 'CORE_UPDATE_PROFILE_REQUEST'
export const CORE_UPDATE_PROFILE_SUCCESS = 'CORE_UPDATE_PROFILE_SUCCESS'
export const CORE_UPDATE_PROFILE_FAILURE = 'CORE_UPDATE_PROFILE_FAILURE'

//PRODUCT
export const CORE_LOAD_ALL_PRODUCT_REQUEST = 'CORE_LOAD_ALL_PRODUCT_REQUEST'
export const CORE_LOAD_ALL_PRODUCT_SUCCESS = 'CORE_LOAD_ALL_PRODUCT_SUCCESS'
export const CORE_LOAD_ALL_PRODUCT_FAILURE = 'CORE_LOAD_ALL_PRODUCT_FAILURE'

export const CORE_LOAD_PRODUCT_REQUEST = 'CORE_LOAD_PRODUCT_REQUEST'
export const CORE_LOAD_PRODUCT_SUCCESS = 'CORE_LOAD_PRODUCT_SUCCESS'
export const CORE_LOAD_PRODUCT_FAILURE = 'CORE_LOAD_PRODUCT_FAILURE'

export const CORE_DELETE_PRODUCT_REQUEST = 'CORE_DELETE_PRODUCT_REQUEST'
export const CORE_DELETE_PRODUCT_SUCCESS = 'CORE_DELETE_PRODUCT_SUCCESS'
export const CORE_DELETE_PRODUCT_FAILURE = 'CORE_DELETE_PRODUCT_FAILURE'

export const CORE_CREATE_PRODUCT_REQUEST = 'CORE_CREATE_PRODUCT_REQUEST'
export const CORE_CREATE_PRODUCT_SUCCESS = 'CORE_CREATE_PRODUCT_SUCCESS'
export const CORE_CREATE_PRODUCT_FAILURE = 'CORE_CREATE_PRODUCT_FAILURE'

export const CORE_UPDATE_PRODUCT_REQUEST = 'CORE_UPDATE_PRODUCT_REQUEST'
export const CORE_UPDATE_PRODUCT_SUCCESS = 'CORE_UPDATE_PRODUCT_SUCCESS'
export const CORE_UPDATE_PRODUCT_FAILURE = 'CORE_UPDATE_PRODUCT_FAILURE'

export const CORE_UPVERSION_PRODUCT_REQUEST = 'CORE_UPVERSION_PRODUCT_REQUEST'
export const CORE_UPVERSION_PRODUCT_SUCCESS = 'CORE_UPVERSION_PRODUCT_SUCCESS'
export const CORE_UPVERSION_PRODUCT_FAILURE = 'CORE_UPVERSION_PRODUCT_FAILURE'

//VERSION
export const CORE_LOAD_ALL_VERSION_REQUEST = 'CORE_LOAD_ALL_VERSION_REQUEST'
export const CORE_LOAD_ALL_VERSION_SUCCESS = 'CORE_LOAD_ALL_VERSION_SUCCESS'
export const CORE_LOAD_ALL_VERSION_FAILURE = 'CORE_LOAD_ALL_VERSION_FAILURE'

export const CORE_LOAD_VERSION_REQUEST = 'CORE_LOAD_VERSION_REQUEST'
export const CORE_LOAD_VERSION_SUCCESS = 'CORE_LOAD_VERSION_SUCCESS'
export const CORE_LOAD_VERSION_FAILURE = 'CORE_LOAD_VERSION_FAILURE'

export const CORE_DELETE_VERSION_REQUEST = 'CORE_DELETE_VERSION_REQUEST'
export const CORE_DELETE_VERSION_SUCCESS = 'CORE_DELETE_VERSION_SUCCESS'
export const CORE_DELETE_VERSION_FAILURE = 'CORE_DELETE_VERSION_FAILURE'

export const CORE_CREATE_VERSION_REQUEST = 'CORE_CREATE_VERSION_REQUEST'
export const CORE_CREATE_VERSION_SUCCESS = 'CORE_CREATE_VERSION_SUCCESS'
export const CORE_CREATE_VERSION_FAILURE = 'CORE_CREATE_VERSION_FAILURE'

export const CORE_UPDATE_VERSION_REQUEST = 'CORE_UPDATE_VERSION_REQUEST'
export const CORE_UPDATE_VERSION_SUCCESS = 'CORE_UPDATE_VERSION_SUCCESS'
export const CORE_UPDATE_VERSION_FAILURE = 'CORE_UPDATE_VERSION_FAILURE'

//DEVICE
export const CORE_LOAD_ALL_DEVICE_REQUEST = 'CORE_LOAD_ALL_DEVICE_REQUEST'
export const CORE_LOAD_ALL_DEVICE_SUCCESS = 'CORE_LOAD_ALL_DEVICE_SUCCESS'
export const CORE_LOAD_ALL_DEVICE_FAILURE = 'CORE_LOAD_ALL_DEVICE_FAILURE'

export const CORE_LOAD_DEVICE_REQUEST = 'CORE_LOAD_DEVICE_REQUEST'
export const CORE_LOAD_DEVICE_SUCCESS = 'CORE_LOAD_DEVICE_SUCCESS'
export const CORE_LOAD_DEVICE_FAILURE = 'CORE_LOAD_DEVICE_FAILURE'

export const CORE_DELETE_DEVICE_REQUEST = 'CORE_DELETE_DEVICE_REQUEST'
export const CORE_DELETE_DEVICE_SUCCESS = 'CORE_DELETE_DEVICE_SUCCESS'
export const CORE_DELETE_DEVICE_FAILURE = 'CORE_DELETE_DEVICE_FAILURE'

export const CORE_CREATE_DEVICE_REQUEST = 'CORE_CREATE_DEVICE_REQUEST'
export const CORE_CREATE_DEVICE_SUCCESS = 'CORE_CREATE_DEVICE_SUCCESS'
export const CORE_CREATE_DEVICE_FAILURE = 'CORE_CREATE_DEVICE_FAILURE'

export const CORE_UPDATE_DEVICE_REQUEST = 'CORE_UPDATE_DEVICE_REQUEST'
export const CORE_UPDATE_DEVICE_SUCCESS = 'CORE_UPDATE_DEVICE_SUCCESS'
export const CORE_UPDATE_DEVICE_FAILURE = 'CORE_UPDATE_DEVICE_FAILURE'

//LICENSETYPE
export const CORE_LOAD_ALL_LICENSETYPE_REQUEST = 'CORE_LOAD_ALL_LICENSETYPE_REQUEST'
export const CORE_LOAD_ALL_LICENSETYPE_SUCCESS = 'CORE_LOAD_ALL_LICENSETYPE_SUCCESS'
export const CORE_LOAD_ALL_LICENSETYPE_FAILURE = 'CORE_LOAD_ALL_LICENSETYPE_FAILURE'

export const CORE_LOAD_LICENSETYPE_REQUEST = 'CORE_LOAD_LICENSETYPE_REQUEST'
export const CORE_LOAD_LICENSETYPE_SUCCESS = 'CORE_LOAD_LICENSETYPE_SUCCESS'
export const CORE_LOAD_LICENSETYPE_FAILURE = 'CORE_LOAD_LICENSETYPE_FAILURE'

//LICENSE
export const CORE_LOAD_ALL_LICENSE_REQUEST = 'CORE_LOAD_ALL_LICENSE_REQUEST'
export const CORE_LOAD_ALL_LICENSE_SUCCESS = 'CORE_LOAD_ALL_LICENSE_SUCCESS'
export const CORE_LOAD_ALL_LICENSE_FAILURE = 'CORE_LOAD_ALL_LICENSE_FAILURE'

export const CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST = 'CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST'
export const CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS = 'CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS'
export const CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE = 'CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE'

export const CORE_LOAD_ALL_LICENSE_IOT_REQUEST = 'CORE_LOAD_ALL_LICENSE_IOT_REQUEST'
export const CORE_LOAD_ALL_LICENSE_IOT_SUCCESS = 'CORE_LOAD_ALL_LICENSE_IOT_SUCCESS'
export const CORE_LOAD_ALL_LICENSE_IOT_FAILURE = 'CORE_LOAD_ALL_LICENSE_IOT_FAILURE'

export const CORE_LOAD_LICENSE_REQUEST = 'CORE_LOAD_LICENSE_REQUEST'
export const CORE_LOAD_LICENSE_SUCCESS = 'CORE_LOAD_LICENSE_SUCCESS'
export const CORE_LOAD_LICENSE_FAILURE = 'CORE_LOAD_LICENSE_FAILURE'

export const CORE_DELETE_LICENSE_REQUEST = 'CORE_DELETE_LICENSE_REQUEST'
export const CORE_DELETE_LICENSE_SUCCESS = 'CORE_DELETE_LICENSE_SUCCESS'
export const CORE_DELETE_LICENSE_FAILURE = 'CORE_DELETE_LICENSE_FAILURE'

export const CORE_CREATE_LICENSE_REQUEST = 'CORE_CREATE_LICENSE_REQUEST'
export const CORE_CREATE_LICENSE_SUCCESS = 'CORE_CREATE_LICENSE_SUCCESS'
export const CORE_CREATE_LICENSE_FAILURE = 'CORE_CREATE_LICENSE_FAILURE'

export const CORE_UPDATE_LICENSE_REQUEST = 'CORE_UPDATE_LICENSE_REQUEST'
export const CORE_UPDATE_LICENSE_SUCCESS = 'CORE_UPDATE_LICENSE_SUCCESS'
export const CORE_UPDATE_LICENSE_FAILURE = 'CORE_UPDATE_LICENSE_FAILURE'

export const CORE_UNREGISTER_LICENSE_REQUEST = 'CORE_UNREGISTER_LICENSE_REQUEST'
export const CORE_UNREGISTER_LICENSE_SUCCESS = 'CORE_UNREGISTER_LICENSE_SUCCESS'
export const CORE_UNREGISTER_LICENSE_FAILURE = 'CORE_UNREGISTER_LICENSE_FAILURE'

//IOTACCESSORY
export const CORE_LOAD_ALL_IOTACCESSORY_REQUEST = 'CORE_LOAD_ALL_IOTACCESSORY_REQUEST'
export const CORE_LOAD_ALL_IOTACCESSORY_SUCCESS = 'CORE_LOAD_ALL_IOTACCESSORY_SUCCESS'
export const CORE_LOAD_ALL_IOTACCESSORY_FAILURE = 'CORE_LOAD_ALL_IOTACCESSORY_FAILURE'

export const CORE_LOAD_IOTACCESSORY_REQUEST = 'CORE_LOAD_IOTACCESSORY_REQUEST'
export const CORE_LOAD_IOTACCESSORY_SUCCESS = 'CORE_LOAD_IOTACCESSORY_SUCCESS'
export const CORE_LOAD_IOTACCESSORY_FAILURE = 'CORE_LOAD_IOTACCESSORY_FAILURE'

export const CORE_DELETE_IOTACCESSORY_REQUEST = 'CORE_DELETE_IOTACCESSORY_REQUEST'
export const CORE_DELETE_IOTACCESSORY_SUCCESS = 'CORE_DELETE_IOTACCESSORY_SUCCESS'
export const CORE_DELETE_IOTACCESSORY_FAILURE = 'CORE_DELETE_IOTACCESSORY_FAILURE'

export const CORE_CREATE_IOTACCESSORY_REQUEST = 'CORE_CREATE_IOTACCESSORY_REQUEST'
export const CORE_CREATE_IOTACCESSORY_SUCCESS = 'CORE_CREATE_IOTACCESSORY_SUCCESS'
export const CORE_CREATE_IOTACCESSORY_FAILURE = 'CORE_CREATE_IOTACCESSORY_FAILURE'

export const CORE_UPDATE_IOTACCESSORY_REQUEST = 'CORE_UPDATE_IOTACCESSORY_REQUEST'
export const CORE_UPDATE_IOTACCESSORY_SUCCESS = 'CORE_UPDATE_IOTACCESSORY_SUCCESS'
export const CORE_UPDATE_IOTACCESSORY_FAILURE = 'CORE_UPDATE_IOTACCESSORY_FAILURE'

//IOTROOM
export const CORE_LOAD_ALL_IOTROOM_REQUEST = 'CORE_LOAD_ALL_IOTROOM_REQUEST'
export const CORE_LOAD_ALL_IOTROOM_SUCCESS = 'CORE_LOAD_ALL_IOTROOM_SUCCESS'
export const CORE_LOAD_ALL_IOTROOM_FAILURE = 'CORE_LOAD_ALL_IOTROOM_FAILURE'

export const CORE_LOAD_IOTROOM_REQUEST = 'CORE_LOAD_IOTROOM_REQUEST'
export const CORE_LOAD_IOTROOM_SUCCESS = 'CORE_LOAD_IOTROOM_SUCCESS'
export const CORE_LOAD_IOTROOM_FAILURE = 'CORE_LOAD_IOTROOM_FAILURE'

export const CORE_DELETE_IOTROOM_REQUEST = 'CORE_DELETE_IOTROOM_REQUEST'
export const CORE_DELETE_IOTROOM_SUCCESS = 'CORE_DELETE_IOTROOM_SUCCESS'
export const CORE_DELETE_IOTROOM_FAILURE = 'CORE_DELETE_IOTROOM_FAILURE'

export const CORE_CREATE_IOTROOM_REQUEST = 'CORE_CREATE_IOTROOM_REQUEST'
export const CORE_CREATE_IOTROOM_SUCCESS = 'CORE_CREATE_IOTROOM_SUCCESS'
export const CORE_CREATE_IOTROOM_FAILURE = 'CORE_CREATE_IOTROOM_FAILURE'

export const CORE_UPDATE_IOTROOM_REQUEST = 'CORE_UPDATE_IOTROOM_REQUEST'
export const CORE_UPDATE_IOTROOM_SUCCESS = 'CORE_UPDATE_IOTROOM_SUCCESS'
export const CORE_UPDATE_IOTROOM_FAILURE = 'CORE_UPDATE_IOTROOM_FAILURE'

export const CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST = 'CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST'
export const CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS = 'CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS'
export const CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE = 'CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE'


// WEBPACK FOOTER //
// ./src/types.js